import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import theme from "./theme/theme";
import Login from "./componentes/seguridad/Login";
import RegistrarUsuario from "./componentes/seguridad/Registrar";
import { Grid, Snackbar } from "@material-ui/core";
import MainDashboard from "./componentes/MainDashboard/MainDashboard";
import NoMatchPage from "./componentes/noMatchPage/NoMatchPage";
import RecoverPassword from "./componentes/seguridad/Recovery/RestorePassword";
import { useStateValue } from "./context/store";
import SecureRoute from "./componentes/seguridad/secure-route";
import ValidatePassword from "./componentes/seguridad/validatePassword";
import Recovery from "./componentes/seguridad/Recovery/Recovery";
import Upps from "./componentes/seguridad/Recovery/Upps";
import Success from "./componentes/seguridad/Recovery/Success";
import SuccessReset from "./componentes/reset-password-page/components/Success";
import RestorePassword from "./componentes/seguridad/Recovery/RestorePassword";
import "./App.css";
import DinamicLoaderApp from "./componentes/microfrontent-pages/dinamic-loader-app";
import NotAuthorized from "./pages/notAuthorized";
import ModalConfirmBase from "./utils/form/modalConfirmBase";
import { ContextSearchUserProvider } from "./context/reducers/contextSearchUser";
import PublicVacancie from "./pages/public vacancies/public-vacancie";

const queryClient = new QueryClient();

function App() {
  const [{ openSnackbar, snackbarMessage }, dispatch] = useStateValue();
  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <ModalConfirmBase
          open={openSnackbar ? openSnackbar.open : false}
          description={openSnackbar && openSnackbar.message}
          handleClickOut={() =>
            dispatch({
              type: "OPEN_SNACKBAR",
              openMessage: {
                open: false,
                message: "",
                severity: "warning",
              },
            })
          }
          handleClick={() =>
            dispatch({
              type: "OPEN_SNACKBAR",
              openMessage: {
                open: false,
                message: "",
                severity: "warning",
              },
            })
          }
          handleClickPrint={() =>
            dispatch({
              type: "OPEN_SNACKBAR",
              openMessage: {
                open: false,
                message: "",
                severity: "warning",
              },
            })
          }
          textButtonSubmit="Aceptar"
          type="WARNING"
          oneButtons={true}
          threeButtons={true}
        />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={snackbarMessage ? snackbarMessage.open : false}
          autoHideDuration={3000}
          message={openSnackbar ? openSnackbar.mensaje : ""}
          ContentProps={{ "aria-describedby": "message-id" }}
          onClose={() =>
            dispatch({
              type: "SNACKBAR_MESSAGE",
              openMessageToast: {
                open: false,
                message: "",
              },
            })
          }
        >
          {snackbarMessage ? snackbarMessage.message : ""}
        </Snackbar>
        <BrowserRouter>
          <MuiThemeProvider theme={theme}>
            <Grid id="mainGridContainer" style={{ backgroundColor: "#E0F2F7" }}>
              <Switch>
                <Route
                  exact
                  path="/"
                  component={() => <Redirect to="/auth/login" />}
                />
                <Route exact path="/auth/login" component={Login} />
                <Route
                  exact
                  path="/auth/validate"
                  component={ValidatePassword}
                />
                <Route exact path="/auth/reset/" component={RecoverPassword} />
                <Route exact path="/auth/login/:message" component={Login} />
                <Route
                  exact
                  path="/auth/registrar"
                  component={RegistrarUsuario}
                />
                <Route exact path="/auth/recuperar" component={Recovery} />
                <Route
                  exact
                  path="/auth/restaurar-password"
                  component={RestorePassword}
                />
                <Route exact path="/auth/upps" component={Upps} />
                <Route exact path="/auth/success" component={Success} />

                <Route
                  exact
                  path="/auth/success-reset"
                  component={SuccessReset}
                />
                <Route exact path="/vacancies" component={PublicVacancie} />
                <SecureRoute
                  exact
                  path="/dashboard/applications/:appName/:operation"
                  component={DinamicLoaderApp}
                />
                <ContextSearchUserProvider>
                  <SecureRoute path="/dashboard" component={MainDashboard} />
                </ContextSearchUserProvider>
                <Route path="/pages/forbidden" component={NotAuthorized} />
                <Route path="/pages/notFound" component={NoMatchPage} />
                <Route path="*">
                  <NoMatchPage />
                </Route>
              </Switch>
            </Grid>
          </MuiThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </React.Fragment>
  );
}

export default App;
